export const FuelSelection = ({fuels, selectedFuelsIds, onFilterChange}) => {
    const toggleSelection = (fuelId) => {
        let newSelection;
        if (selectedFuelsIds.includes(fuelId)) {
            newSelection = selectedFuelsIds.filter(id => id !== fuelId);
        } else {
            newSelection = [...selectedFuelsIds, fuelId];
        }
        onFilterChange(newSelection);
    };

    return (
        <div className="flex flex-wrap">
            {fuels.map((fuel) => (
                    <div key={fuel.id} className="mr-3 mb-1">
                        <div id={'fuel-' + fuel.id} onClick={() => toggleSelection(fuel.id)} className={`relative flex items-start justify-start cursor-pointer hover:scale-[1.1] transition duration-150 ease-in-out py-1 bg-white border-b border-b-gray-300'`}>
                            <div className="absolute top-0 right-0 rounded opacity-25 bg-gray-400 w-full h-full" style={{display: selectedFuelsIds.includes(fuel.id) ? 'block' : 'none'}}/>
                            <div className="text-xs uppercase px-2">
                                {fuel.name}
                            </div>
                        </div>
                    </div>
                )
            )}
        </div>
    )
        ;
}